import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BusinessReportsCharts } from '../components/charts/BusinessReportsCharts';
function TabPanel(props) {
  const { children, ...rest } = props;
  return (
    <div role="tabpanel" {...rest}>
      <Box component="div" p={3}>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  );
}
export function BusinessReports() {
  const metrics = [
    'totalCallsOptions',
    'outgoingCallsOptions',
    'incomingCallsOptions',
  ];
  return (
    <div style={{ maxWidth: '100%' }}>
      <TabPanel>
        {metrics.map((singleMetric, key) => (
          <BusinessReportsCharts key={key} metric={singleMetric} />
        ))}
      </TabPanel>
    </div>
  );
}
